import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { CompetitionMatchEffects } from './competition-match.effects'
import * as fromCompetitionMatch from './competition-match.reducer'
import { CompetitionMatchSerializer } from './competition-match.serializer'
import { CompetitionMatchService } from './competition-match.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromCompetitionMatch.FEATURE_NAME,
      fromCompetitionMatch.competitionMatchReducer
    ),
    EffectsModule.forFeature([CompetitionMatchEffects])
  ],
  providers: [
    CompetitionMatchService,
    {
      provide: CompetitionMatchSerializer,
      useClass: CompetitionMatchSerializer
    }
  ],
  declarations: []
})
export class CompetitionMatchModule {}
